<template>
  <el-select
    v-model="drivetrainModel"
    @change="drivetrainChanged"
    :placeholder="$t('DRIVETRAIN.DRIVETRAIN')"
    :filterable="filterable"
    :disabled="disabled"
  >
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')" />
    <el-option
      v-for="option in drivetrainOptionsArray"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    />
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";
import { drivetrainOptions } from "../constants/drivetrain";

export default {
  name: "drivetrain-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    value: {
      type: String | Number | null | undefined,
      default: null,
      description: "Value",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Allow null value",
    },
    options: {
      type: Array | undefined | null,
      default: null,
    },
  },

  data() {
    const drivetrainModel = this.value?.toLowerCase() ?? null;
    return {
      drivetrainModel,
      drivetrainOptions,
    };
  },

  setup() {},

  created() {},

  computed: {
    drivetrainOptionsArray: function () {
      if (Array.isArray(this.options) && this.options.length > 0) {
        return this.options.map((value) => ({
          value,
          label: this.label(value),
        }));
      }

      return Object.entries(this.drivetrainOptions).map(([key, value]) => ({
        value,
        label: this.label(key),
      }));
    },
  },

  methods: {
    drivetrainChanged(drivetrain) {
      this.$emit("drivetrainChanged", drivetrain?.toLowerCase());
    },
    label(option) {
      return this.$tc(`DRIVETRAIN.DRIVETRAIN_${option.toUpperCase()}`)
        ? this.$t(`DRIVETRAIN.DRIVETRAIN_${option.toUpperCase()}`)
        : option;
    },
  },

  watch: {
    value() {
      this.drivetrainModel = this.value?.toLowerCase();
    },
  },
};
</script>
